export default "__VITE_ASSET__Dpgajeh$__"